import { Form } from 'react-bootstrap'
import styled from 'styled-components'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string
  options: { id: string; value: string | number; label: string }[]
  label?: string
  checked: string | undefined | number
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const Radio = ({ options, label, name, checked, onChange, ...otherProps }: IProps) => {
  return (
    <Div {...otherProps}>
      {label && <h3>{label}</h3>}

      <div className="options">
        {options.map((option) => {
          return (
            <div className="option" key={option.id}>
              <Form.Check
                type="radio"
                onChange={onChange}
                name={name}
                id={option.id}
                value={option.value}
                checked={checked === option.value}
              />
              <label htmlFor={option.id}>{option.label}</label>
            </div>
          )
        })}
      </div>
    </Div>
  )
}

const Div = styled.div`
  color: ${({ theme }) => theme.colors.primary.darker};

  h3 {
    margin-bottom: 1rem;
    ${({ theme }) => theme.typography.m.normal};
    line-height: 150%;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }

  .options {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    .option {
      display: flex;
      align-items: center;
      gap: 1rem;
      font-weight: ${({ theme }) => theme.fontWeight.normal};

      label {
        cursor: pointer;
      }
    }
  }
`
